import { cx } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import { message } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

interface SimpleInputNumberProps {
  min?: number;
  max?: number;
  value?: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  className?: string;
}

export const SimpleInputNumber = (props: SimpleInputNumberProps) => {
  const { min, max, value = 0, onChange, disabled = false, className } = props;
  const { t } = useTranslate();
  return (
    <div
      className={cx('rounded-[4px] bg-[#fff] flex items-center', className, {
        'cursor-not-allowed': disabled,
        'text-[#F7F9FA]': disabled,
      })}
    >
      <div
        className={cx('w-[28px] h-[28px] flex items-center justify-center cursor-pointer', {
          '!cursor-not-allowed text-[#cccdcf]': disabled || (min !== undefined && value <= min),
        })}
        onClick={(e) => {
          e.stopPropagation();
          if (disabled) return;
          if (min !== undefined && value <= min) return message.warn(t('最少x件', { x: min }));
          onChange?.(value - 1);
        }}
      >
        <MinusOutlined />
      </div>
      <div className="px-2 w-fit flex items-center justify-center text-[#232426]">{value}</div>
      <div
        className={cx('w-[28px] h-[28px] flex items-center justify-center cursor-pointer', {
          '!cursor-not-allowed text-[#cccdcf]': disabled || (max !== undefined && value >= max),
        })}
        onClick={(e) => {
          e.stopPropagation();
          if (disabled) return;
          if (max !== undefined && value >= max) return message.warn(t('最对x件', { x: max }));
          onChange?.(value + 1);
        }}
      >
        <PlusOutlined />
      </div>
    </div>
  );
};

SimpleInputNumber.displayName = 'SimpleInputNumber';
